<script setup lang="ts">
defineProps<{
  title?: string,
}>();
</script>
<template>
  <div class="flex flex-col bg-white rounded-lg shadow-lg p-4 sm:p-6">
    <h3 v-if="title" class="mb-3 sm:mb-5">{{ title }}</h3>
    <slot />
  </div>
</template>
